<template>
    <v-container>
        <v-card>
            <v-card-title>{{event_title}} <v-spacer></v-spacer> <v-icon class="no-print" aria-label="print your event pass" tabindex="0" @click="printEventPass()">print</v-icon></v-card-title>
            <v-card-subtitle>Event Pass</v-card-subtitle>
            <v-card-text>
                <p style="text-align:center;font-weight:bolder;font-size:16px">Scan to check-in</p>
                <v-img :src="eventpass_qrcode_dataurl" height="300px" width="300px" style="margin:0 auto"></v-img>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
import QrCode from 'qrcode'
export default {
    data: () => ({
        event_title: "",
        eventpass_qrcode_dataurl: ""
    }),
    created() {
        this.event_title = this.$route.params.event_title
        this.generateQrCode(this.$route.params.userid).then(res => {
            this.eventpass_qrcode_dataurl = res
        }).catch(err => {
            console.log("qrcode gen error:", err)
        })
    },
    methods: {
        async generateQrCode(qrtext) {
            var dataurl = ""
            await QrCode.toDataURL(qrtext).then(res => {
                dataurl = res;
            })
            return dataurl

        },
        printEventPass(){
            window.print()
        }
    }
}
</script>